export default "__VITE_ASSET__DjGkoZqk__"